import styles from './StatCard.module.css';

interface StatCardProps {
  value: string;
  label: string;
}

export function StatCard({value, label}: StatCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.value}>{value}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
